import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

export const NetworksContainer = styled('div')`
  width: 400px;
  margin: 0 -30px 20px -30px;
  max-height: 460px;
  z-index: 1000;
`;
export const NetworksTitle = styled('div')`
  font-weight: 500;
  font-size: 18px;
  color: ${baseTheme.colors.mainLightBlue};
`;

export const NetworksBlock = styled('div')`
  margin-top: 24px;
  .network-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
    width: 100%;
    cursor: pointer;
    border-bottom: 1px solid ${baseTheme.colors.stroking};
    &:hover {
      background-color: rgba(10, 119, 199, 0.1);
    }
  }

  .network {
    padding: 6px 12px;
  }
  .green-point {
    background-color: #1fa069;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
`;

export const SearchBarInput = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  width: 100%;
  height: 48px;
  border: 1px solid ${baseTheme.colors.stroking};
  border-radius: 8px;
  position: relative;

  input {
    width: 100%;
    color: ${baseTheme.colors.secondary};
    font-size: 16px;
    -webkit-appearance: none;
    border: none;
    padding: 0;
    background-color: inherit;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: ${baseTheme.colors.tertiary};
    }
  }
`;
